




























import { OperationMode, operationModes } from '@spa/components/organisms/cart/model/item/operation-mode'
import OrderItem from '@spa/components/pages/order/order/order-list/editable/OrderItem.vue'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import {
  kind as OrderKind,
  Order
} from '@spa/services/order'
import { CartItem } from '@spa/store/modules/cart/types'

@Component({
  components: {
    OrderItem,
  },
})
export default class OrderListItem extends Vue {
  @Prop({ required: true })
  order: Order

  @Prop({ default: () => operationModes.readOnly })
  operationMode: OperationMode

  get labelDeliveryWhen(): string {
    const when = this.order.deliveryWhen

    if (this.orderIsPreOrder) {
      return `${when}頃を予定`
    }

    return when === null ? '未指定' : when
  }

  get orderIsPreOrder(): boolean {
    return this.order.kind === OrderKind.PreOrder
  }

  get showItems(): CartItem[] {
    return _.filter(this.order.cartItems, (item: CartItem) => {
      return !item.isChild
    })
  }

  @Emit()
  changeCount(_item: CartItem, _newCount: number): void {
    // nothing to do
  }
  @Emit()
  remove(_item: CartItem): void {
    // nothing to do
  }
}
